import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import PropTypesHelpers from '../../utils/propTypesHelpers'

import ButtonClose from './ButtonClose'

const ModalHeader = ({ children, onClose, className, closeLabel }) => (
  <div className={classnames('modal-header', className)}>
    <h5 className='modal-title'>{children}</h5>
    {onClose &&
      <ButtonClose onClick={onClose} label={closeLabel} />}
  </div>
)

ModalHeader.propTypes = {
  onClose: PropTypes.func,
  className: PropTypesHelpers.classnames,
  closeLabel: PropTypes.string,
  children: PropTypesHelpers.children
}

export default ModalHeader
